export default __webpack_public_path__ + "static/vm-list-668e35fed583e4dd5c899c06d6b4a51d.jpg";